import type { ChangeEvent } from 'react'

import { Tooltip as ReactTooltip } from 'react-tooltip'

import { Box } from 'app/components/design-system-components'
import { CheckBoxGeneral } from 'app/components/forms/forms'
import { TEAM_ADMIN_UPDATE_TOOLTIP_SUFFIX } from 'app/sm/team_viewing_preference/applications/premier-plan-setting.constants'
import { applicationsAttributesIDs } from 'app/sm/team_viewing_preference/applications-attributes.constants'

const TOOLTIP_ID = 'saAutoRentalReferenceInfo'
const PAID_PLAN_TOOLTIP_SUFFIX = 'Available on paid plans.'

export const SA_AUTO_RENTAL_REFERENCE_LABEL =
  'Automate SA current address rental references'

export const SA_AUTO_RENTAL_REFERENCE_TOOLTIP =
  'When enabled, SA applications with an agent or owner/landlord current address referee automatically send a rental reference request when submitted.'

export const getSAAutoRentalReferenceTooltipText = ({
  isPaidPlan,
  isUserAdmin,
}: Pick<SAAutoRentalReferenceSettingProps, 'isPaidPlan' | 'isUserAdmin'>) =>
  `${SA_AUTO_RENTAL_REFERENCE_TOOLTIP} ${
    !isPaidPlan
      ? PAID_PLAN_TOOLTIP_SUFFIX
      : !isUserAdmin
      ? TEAM_ADMIN_UPDATE_TOOLTIP_SUFFIX
      : ''
  }`.trim()

export interface SAAutoRentalReferenceSettingProps {
  isVisible: boolean
  isChecked: boolean
  isUserAdmin: boolean
  isPaidPlan: boolean
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
}

export const SAAutoRentalReferenceSetting = ({
  isVisible,
  isChecked,
  isUserAdmin,
  isPaidPlan,
  onChange,
}: SAAutoRentalReferenceSettingProps): JSX.Element | null => {
  if (!isVisible) {
    return null
  }

  const isDisabled = !isUserAdmin || !isPaidPlan
  const tooltipText = getSAAutoRentalReferenceTooltipText({
    isPaidPlan,
    isUserAdmin,
  })

  return (
    <>
      <div className="mb15">
        <CheckBoxGeneral
          id={applicationsAttributesIDs.saAutoRentalReferenceEnabled}
          label={SA_AUTO_RENTAL_REFERENCE_LABEL}
          onChange={onChange}
          checked={isChecked}
          eventProcessedByComponent
          disabled={isDisabled}
          showDisabledGrey={isDisabled}
          toolTip={
            (
              <div>
                <i
                  className="icon-help-outline fs16 gray-light-color ibm"
                  data-tooltip-content=""
                  data-tooltip-id={TOOLTIP_ID}
                />
              </div>
            ) as unknown as string // CheckBoxGeneral is a JS base component; proper toolTip typing needs changes there first.
          }
        />
      </div>

      <div>
        <ReactTooltip id={TOOLTIP_ID} className="tool-tip-style">
          <Box maxWidth="260px">{tooltipText}</Box>
        </ReactTooltip>
      </div>
    </>
  )
}

export default SAAutoRentalReferenceSetting
